import { render, staticRenderFns } from "./ReferenceActionControls.vue?vue&type=template&id=c90635ae&scoped=true&"
import script from "./ReferenceActionControls.vue?vue&type=script&lang=js&"
export * from "./ReferenceActionControls.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceActionControls.vue?vue&type=style&index=0&id=c90635ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90635ae",
  null
  
)

export default component.exports